import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Table, Tag } from 'tdesign-react';
import { isVoid } from '@/utils/common';

export default function ReplicasError({ info, primaryClusterName, recoveryClusterName, topic }) {
  const data = useMemo(() => {
    const primaryValue = info[primaryClusterName] || {};
    const recoveryValue = info[recoveryClusterName] || {};
    const { bookkeeperAckQuorum, bookkeeperEnsemble, bookkeeperWriteQuorum } = primaryValue;
    const {
      bookkeeperAckQuorum: bookkeeperAckQuorum2,
      bookkeeperEnsemble: bookkeeperEnsemble2,
      bookkeeperWriteQuorum: bookkeeperWriteQuorum2,
    } = recoveryValue;
    const ensembleSame = bookkeeperEnsemble === bookkeeperEnsemble2;
    const writeQuorumSame = bookkeeperWriteQuorum === bookkeeperWriteQuorum2;
    const ackQuorumSame = bookkeeperAckQuorum === bookkeeperAckQuorum2;
    const list = [
      {
        clusterName: primaryClusterName,
        isPrimary: true,
        ensemble: isVoid(bookkeeperEnsemble) ? '-' : bookkeeperEnsemble,
        ensembleSame,
        writeQuorum: isVoid(bookkeeperWriteQuorum) ? '-' : bookkeeperWriteQuorum,
        writeQuorumSame,
        ackQuorum: isVoid(bookkeeperAckQuorum) ? '-' : bookkeeperAckQuorum,
        ackQuorumSame,
      },
      {
        clusterName: recoveryClusterName,
        ensemble: isVoid(bookkeeperEnsemble2) ? '-' : bookkeeperEnsemble2,
        ensembleSame,
        writeQuorum: isVoid(bookkeeperWriteQuorum2) ? '-' : bookkeeperWriteQuorum2,
        writeQuorumSame,
        ackQuorum: isVoid(bookkeeperAckQuorum2) ? '-' : bookkeeperAckQuorum2,
        ackQuorumSame,
      },
    ];

    return list;
  }, [info, primaryClusterName, recoveryClusterName]);

  const columns = [
    {
      title: '所属集群',
      colKey: 'clusterName',
      width: 260,
      cell: ({ row }) => {
        return `${row.clusterName} （${row.isPrimary ? '主' : '备'}）`;
      },
    },
    {
      title: 'Ensemble',
      colKey: 'ensemble',
      width: 150,
      cell: ({ row }) =>
        row.ensembleSame ? (
          row.ensemble
        ) : (
          <b style={{ color: 'var(--td-warning-color)' }}>{row.ensemble}</b>
        ),
    },
    {
      title: 'WriteQuorum',
      colKey: 'writeQuorum',
      width: 150,
      cell: ({ row }) =>
        row.writeQuorumSame ? (
          row.writeQuorum
        ) : (
          <b style={{ color: 'var(--td-warning-color)' }}>{row.writeQuorum}</b>
        ),
    },
    {
      title: 'AckQuorum',
      colKey: 'ackQuorum',
      width: 150,
      cell: ({ row }) =>
        row.ackQuorumSame ? (
          row.ackQuorum
        ) : (
          <b style={{ color: 'var(--td-warning-color)' }}>{row.ackQuorum}</b>
        ),
    },
  ];
  return (
    <>
      <Header theme='primary' variant='light'>
        {topic}
      </Header>
      <Table style={{ width: 800 }} bordered data={data} columns={columns} />
    </>
  );
}

const Header = styled(Tag)`
  margin: 4px 0 7px 2px;
`;
